module.exports = __webpack_public_path__ + "img/Component 13@2x.5a45b68e.png";